import { getEntity } from "./getEntity";
import tib from "../../assets/img/TIB.svg";
import tpf from "../../assets/img/TPF.png";
import logo from "../../assets/img/logo.svg";
import logoConsellFormentera from "../../assets/img/LogoConsellFormentera.png";
import targetaGeneral from "../../assets/img/TargetaGeneral.svg";
import targetaFormentera from "../../assets/img/TargetaFormentera.png";

export interface EntityImageConfig {
  headerLogo: string;
  headerTibLogo: string;
  cardSrc: string;
  cardAltKey: string;
}

const DEFAULT_IMAGE_CONFIG: EntityImageConfig = {
  headerLogo: tib,
  headerTibLogo: logo,
  cardSrc: targetaGeneral,
  cardAltKey: "card.img_alt",
};

const ENTITY_IMAGE_CONFIGS: Record<string, Partial<EntityImageConfig>> = {
  "5": {
    headerLogo: tpf,
    headerTibLogo: logoConsellFormentera,
    cardSrc: targetaFormentera,
    cardAltKey: "card.img_alt_tpf",
  },
};

export const getEntityImageConfig = (): EntityImageConfig => ({
  ...DEFAULT_IMAGE_CONFIG,
  ...ENTITY_IMAGE_CONFIGS[getEntity().id],
});
